function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocksymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 264 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 20837",
    style: {
      fill: "#f3f6fa"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C3.864 15.5.5 12.136.5 8S3.864.5 8 .5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7m0-1a8 8 0 1 1 0 16A8 8 0 0 1 8 0z",
    style: {
      fill: "#e5edf6",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20834",
    d: "M11.143 5.429h-.571V3.714a1.714 1.714 0 1 0-3.429 0v1.715h-.572A.571.571 0 0 0 6 6v3.429a.571.571 0 0 0 .571.571h4.571a.571.571 0 0 0 .571-.571V6a.571.571 0 0 0-.57-.571zM7.714 3.714a1.143 1.143 0 1 1 2.286 0v1.715H7.714z",
    transform: "translate(-.857 2)",
    style: {
      fill: "#203662"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocksymbol);
export default __webpack_public_path__ + "static/media/Locksymbol.b05291b490ebc3b49eb062cb79ef2119.svg";
export { ForwardRef as ReactComponent };